import { t } from 'ttag'

type ProductInfoGetters = {
  name: () => string
  description: () => string
  info: { title: () => string; body: () => string }
}
type ProductInfoMap = Record<string, ProductInfoGetters>

export const PRODUCT_INFO: ProductInfoMap = {
  '6500': {
    name: () => t`Event ticket (6500)`,
    description: () =>
      t`Activated on the start date. Includes unlimited trips between the start and end dates.`,
    info: {
      title: () => t`Event ticket validity`,
      body: () =>
        t`Tickets are activated at the selected start time and expire at the end time. Suitable for e.g. multi-day events.`
    }
  },
  '6502': {
    name: () => t`Event single-use ticket (6502)`,
    description: () =>
      t`Activated when validated. Includes one trip between the start and end dates.`,
    info: {
      title: () => t`Event single-use ticket validity`,
      body: () =>
        t`Tickets are activated when validated and are then valid for the transfer time. The ticket can be validated between the selected start and end times.`
    }
  },
  '601': {
    name: () => t`Single-use ticket - Adult (601)`,
    description: () =>
      t`Activated when validated. Includes one adult trip. Must be used within two years of ordering.`,
    info: {
      title: () => t`Single-use ticket validity`,
      body: () =>
        t`Tickets are activated when validated and are valid for the transfer time. The ticket must be used within two years of the order date.`
    }
  },
  '602': {
    name: () => t`Single-use ticket - Child (602)`,
    description: () =>
      t`Activated when validated. Includes one child trip. Must be used within two years of ordering.`,
    info: {
      title: () => t`Single-use ticket validity`,
      body: () =>
        t`Tickets are activated when validated and are valid for the transfer time. The ticket must be used within two years of the order date.`
    }
  }
}

export const ALLOWED_PRODUCT_IDS = Object.keys(PRODUCT_INFO)

// Single use ticket validity dates are optional unless the user sets one of them
export const OPTIONAL_DATE_PRODUCT_IDS = ['601', '602']

export function getProductId(fullId: string): string {
  return fullId.split(':').pop() ?? fullId
}

export function getProductNameById(fullId: string): string {
  const shortId = getProductId(fullId)
  return PRODUCT_INFO[shortId]?.name() ?? fullId
}

export function getAuthorityIdFromProductId(fullId: string): string {
  return fullId.split(':')[1] ?? ''
}
